/* global I18n */

import TrackableLink from "../trackable_link"
import React from "react"
import FaIcon from "components/fa_icon"

function PreviewHeader() {
  return (
    <div className="preview-banner">
      <div className="title">
        <FaIcon name={"fa-lock"} text_aligned={true}/>
        {I18n.t("js.quiz_mode_selector.preview.preview_mode")}
      </div>
      <div className="content">
        {I18n.t("js.quiz_mode_selector.preview.unlock_quiz")}
        <TrackableLink
          tracking_event="pricing page clicked"
          tracking_element="quiz_modal"
          href={window.gon.pricing_path}>
          {I18n.t("js.quiz_mode_selector.preview.kenhub_premium")}
          <FaIcon name={"fa-arrow-right"} text_aligned={true}/>
        </TrackableLink>
      </div>
    </div>
  )
}

export default PreviewHeader
